export interface IUIState {
	isChatExpanded: boolean;
}

export const DEFAULT_UI_STATE: IUIState = {
	isChatExpanded: false
};
